import * as React from 'react';

import './Announcement.scss';
export interface AnnouncementStateProps {
  announcement?: string;
}

const Announcement: React.FC<AnnouncementStateProps> = ({ announcement }) => {
  return (
    <div>
      {announcement ? (
        <div className='announcement row p-3'>
          <i className='fas fa-bullhorn'></i>
          <div
            className='message'
            dangerouslySetInnerHTML={{ __html: announcement }}
          ></div>
        </div>
      ) : null}
    </div>
  );
};

export default Announcement;
